export enum ToastPositionX {
  LEFT = 'left',
  RIGHT = 'right',
}

export enum ToastPositionY {
  TOP = 'top',
  BOTTOM = 'bottom',
}

export enum ToastSeverity {
  ERROR = 'error',
  WARNING = 'warning',
  SUCCESS = 'success',
  NEUTRAL = 'neutral',
  INFORMATIVE = 'informative',
}

export enum ToastEvents {
  CLOSED = 'toastClosed',
}

export enum ToastActionButtonMode {
  LINK = 'link',
  BUTTON = 'button',
}

export interface GzToast {
  message: string;
  severity: ToastSeverity;
  hasAction?: boolean;
  showInlineButton?: boolean;
  actionCallback?: null | EventListenerOrEventListenerObject | string;
  x?: ToastPositionX;
  y?: ToastPositionY;
  keepOpen?: boolean;
  canClose?: boolean;
  autoCloseDelayMs?: number;
  actionButtonText?: string;
  actionButtonMode?: ToastActionButtonMode;
}
